export default "__VITE_ASSET__BWaf1HS0__"